import { ArrowRight, FlaskConical, Hammer, NotebookTabs } from 'lucide-react';
import { Link } from 'react-router-dom';

const pillars = [
  {
    label: 'BUILD',
    icon: Hammer,
    copy: 'Small AI and automation systems I actually ship, not just describe.',
  },
  {
    label: 'LAB',
    icon: FlaskConical,
    copy: 'Reproducible experiments with failure modes, controls, and measurable results.',
  },
  {
    label: 'NOTE',
    icon: NotebookTabs,
    copy: 'Clear technical explanations for agents, automation, infrastructure, and security.',
  },
];

const ProofOfWork = () => (
  <section id="proof" className="section-padding border-t border-border bg-background">
    <div className="container-site">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
        <div>
          <span className="chip mb-4">Built, not just written</span>
          <h2 className="max-w-2xl font-display text-3xl font-light uppercase leading-[0.98] tracking-[0.03em] sm:text-4xl lg:text-5xl">
            Practical AI agents, automation, and infrastructure — built, tested, and explained.
          </h2>
          <p className="mt-5 max-w-2xl text-xs uppercase leading-relaxed tracking-wide text-muted-foreground">
            The goal is proof-of-work: runnable builds, observable failures, and notes that show what actually happened.
          </p>
        </div>

        <Link
          to="/lab/agent-audit"
          className="group border border-border bg-card p-6 transition-colors hover:bg-muted/40"
        >
          <div className="flex items-center justify-between gap-4">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">LAB #001</span>
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </div>
          <h3 className="mt-5 max-w-xl font-sans text-lg font-bold uppercase tracking-wider">
            Can you audit everything an AI agent does?
          </h3>
          <p className="mt-3 text-xs leading-relaxed text-muted-foreground">
            Five deterministic scenarios covering normal operation, timeout, duplicate calls, approval boundaries, and recovery strategy.
          </p>
          <div className="mt-5 flex flex-wrap gap-2 text-[9px] font-bold uppercase tracking-wider text-foreground">
            <span className="border border-border px-2 py-1">4 tools</span>
            <span className="border border-border px-2 py-1">5 scenarios</span>
            <span className="border border-border px-2 py-1">Policy + audit trail</span>
          </div>
        </Link>
      </div>

      <div className="mt-8 grid gap-4 md:grid-cols-3">
        {pillars.map(({ label, icon: Icon, copy }) => (
          <article key={label} className="border border-border bg-muted/10 p-5">
            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.18em]">
              <Icon className="h-4 w-4" /> {label}
            </div>
            <p className="mt-3 text-xs leading-relaxed text-muted-foreground">{copy}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProofOfWork;
